var render, staticRenderFns
import script from "./Menu.vue?vue&type=script&lang=tsx"
export * from "./Menu.vue?vue&type=script&lang=tsx"
import style0 from "./Menu.vue?vue&type=style&index=0&id=5546307f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5546307f",
  null
  
)

export default component.exports